import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsSearch2 = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <path
        fill="currentColor"
        d="M9.1593828,0.8953355c-4.5612593-0.0064043-8.264081,3.6860349-8.2704859,8.2472935
		c-0.0064043,4.5612593,3.6860349,8.264081,8.2472935,8.2704859c2.0012102,0.0028095,3.9353685-0.7211018,5.4429512-2.0371733
		l7.5643616,7.5643606c0.2245464,0.2182598,0.5807476,0.2222614,0.8101406,0.0091038
		c0.2134151-0.2327785,0.2094326-0.5912666-0.0091019-0.8192463l-7.5552578-7.5552568
		c2.9947605-3.4390936,2.6345539-8.6547623-0.8045397-11.6495209C13.080781,1.6157308,11.1536474,0.8946419,9.1593828,0.8953355z
		 M9.1593828,2.034996c3.9323483-0.0005028,7.120553,3.1868882,7.1210566,7.1192369s-3.1868877,7.120553-7.1192369,7.1210566
		s-7.120554-3.1868877-7.1210566-7.119236c0-0.0006075,0-0.001214,0-0.0018206
		C2.0356183,5.2269139,5.2156692,2.0395231,9.1429873,2.034996C9.1484518,2.0349896,9.1539173,2.0349896,9.1593828,2.034996"
      />
    </SvgIcon>
  );
});

export default AppIconsSearch2;
